module.exports = __webpack_public_path__ + "static/media/course8.773538c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parentreg/course8.png
// module id = 2847
// module chunks = 0